import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.id}`}
      className="group flex flex-col sm:flex-row gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
    >
      <div className="flex-shrink-0 w-full sm:w-48 h-32 overflow-hidden rounded-lg">
        <img
          src={article.coverImage}
          alt={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          loading="lazy"
        />
      </div>
      <div className="flex flex-col justify-between flex-1 min-w-0">
        <div>
          <div className="flex items-center gap-2 mb-2">
            <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium">
              {article.category}
            </span>
            <span className="text-xs text-foreground-500">{article.readTime}</span>
          </div>
          <h3 className="text-base font-semibold text-foreground-900 line-clamp-2 leading-snug mb-2 group-hover:text-primary-600 transition-colors">
            {article.title}
          </h3>
          <p className="text-sm text-foreground-600 line-clamp-2">
            {article.excerpt}
          </p>
        </div>
        <div className="flex items-center gap-3 mt-3 text-xs text-foreground-500">
          <span>{article.author}</span>
          <span>·</span>
          <span>{article.publishDate}</span>
          <span>·</span>
          <span>{article.views.toLocaleString()} 阅读</span>
        </div>
      </div>
    </Link>
  );
}